(() => {
  const setup = (root) => {
    if (!root || root.dataset.fireraPreviewReady === 'true') return;
    root.dataset.fireraPreviewReady = 'true';

    root.addEventListener('click', (event) => {
      const groupToggle = event.target.closest('.firera-preview-group__toggle');
      if (groupToggle) {
        const group = groupToggle.closest('.firera-preview-group');
        const content = group.querySelector('.firera-preview-group__content');
        const expanded = groupToggle.getAttribute('aria-expanded') === 'true';

        root.querySelectorAll('.firera-preview-group__toggle').forEach((toggle) => {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.querySelector('.firera-preview-group__symbol').textContent = '+';
          toggle.closest('.firera-preview-group').querySelector('.firera-preview-group__content').hidden = true;
        });

        if (!expanded) {
          groupToggle.setAttribute('aria-expanded', 'true');
          groupToggle.querySelector('.firera-preview-group__symbol').textContent = '−';
          content.hidden = false;
        }
        return;
      }

      const previewFilter = event.target.closest('[data-preview-filter]');
      if (previewFilter) {
        previewFilter.classList.toggle('is-selected');
        previewFilter.setAttribute('aria-pressed', String(previewFilter.classList.contains('is-selected')));
        return;
      }

      const moreButton = event.target.closest('[data-preview-more]');
      if (moreButton) {
        const group = moreButton.closest('[data-preview-stones]');
        const extras = group.querySelectorAll('.firera-preview-stone-extra');
        const willShow = extras.length > 0 && extras[0].hidden;
        extras.forEach((item) => { item.hidden = !willShow; });
        moreButton.textContent = willShow ? 'Daha Az Göster ↑' : 'Tüm Taşları Gör ↓';
        return;
      }

      const materialToggle = event.target.closest('[data-firera-material-toggle]');
      if (materialToggle) {
        const materialGroup = materialToggle.dataset.fireraMaterialToggle;
        const nativeInputs = [...root.querySelectorAll(`[data-firera-material-group="${materialGroup}"]`)];
        const nextSelected = !materialToggle.classList.contains('is-selected');

        nativeInputs.forEach((input) => { input.checked = nextSelected; });
        materialToggle.classList.toggle('is-selected', nextSelected);
        materialToggle.setAttribute('aria-pressed', String(nextSelected));

        if (nativeInputs[0]) {
          nativeInputs[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      const filterMoreButton = event.target.closest('[data-firera-filter-more]');
      if (filterMoreButton) {
        const group = filterMoreButton.closest('[data-filter-label="tas-turu"]');
        const lists = group ? [...group.querySelectorAll('.firera-stone-list')] : [];
        const expanded = lists.length > 0 && !lists[0].classList.contains('is-expanded');
        lists.forEach((list) => list.classList.toggle('is-expanded', expanded));
        filterMoreButton.textContent = expanded ? 'Daha Az Göster ↑' : 'Tüm Taşları Gör ↓';
        return;
      }

      const sortClear = event.target.closest('[data-firera-sort-clear]');
      if (sortClear) {
        const recommended = root.querySelector('input[name="sort_by"][value="manual"]');
        if (recommended) recommended.checked = true;
      }
    });

    root.addEventListener('change', (event) => {
      const stoneInput = event.target.closest('[data-firera-stone-filter]');
      if (!stoneInput) return;

      root.querySelectorAll('[data-firera-stone-filter]').forEach((input) => {
        input.closest('.firera-stone-link')?.classList.toggle('is-active', input.checked);
        const check = input.parentElement?.querySelector('.firera-stone-check');
        if (check) check.textContent = input.checked ? '✓' : '';
      });

      const selectedStoneHandles = [...root.querySelectorAll('[data-firera-stone-filter]:checked')]
        .map((input) => input.dataset.tagHandle)
        .filter(Boolean);
      const collectionPath = selectedStoneHandles.length
        ? `${root.dataset.fireraCollectionUrl}/${selectedStoneHandles.join('+')}`
        : root.dataset.fireraCollectionUrl;
      const search = window.location.search;
      window.history.replaceState(window.history.state, '', `${collectionPath}${search}`);
    });

    root.querySelectorAll('[data-firera-preview-clear]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-preview-filter].is-selected').forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
      });
    });
  };

  const syncMobileResultCounts = () => {
    document.querySelectorAll('.firera-collection-preview').forEach((section) => {
      const mobileCount = section.querySelector('.mobile-filters__results-count[data-results-count]');
      const currentCount = section.querySelector('.filter-bar__results-count[data-results-count]')
        || section.querySelector('.filter-drawer__results-count[data-results-count]');

      if (!mobileCount || !currentCount) return;

      const nextText = currentCount.textContent.trim();
      if (nextText && mobileCount.textContent.trim() !== nextText) {
        mobileCount.textContent = nextText;
      }
    });
  };

  const setupAll = () => {
    document.querySelectorAll('.firera-filter-preview').forEach(setup);
    syncMobileResultCounts();
  };

  window.addEventListener('click', (event) => {
    const clearButton = event.target.closest('[data-clear-all-filters], .firera-filter-preview [data-button="clear-all"]');
    if (!clearButton) return;
    const section = clearButton.closest('[data-section-type="collection"]') || document.querySelector('[data-section-type="collection"]');
    const root = section?.querySelector('.firera-filter-preview');
    if (!root?.dataset.fireraCollectionUrl) return;
    window.history.replaceState(window.history.state, '', root.dataset.fireraCollectionUrl);
  }, true);

  document.addEventListener('DOMContentLoaded', setupAll);
  document.addEventListener('shopify:section:load', setupAll);
  new MutationObserver(setupAll).observe(document.documentElement, { childList: true, subtree: true });
})();
